import React, { useState, useEffect } from 'react';

const SearchBox = ({className, placeholder, value, onChange, onPressEnter, onFocus, onBlur}) => {

    const [inputValue, setInputValue] = useState(value);

    useEffect(() => {
        setInputValue(value);
    }, [value]);

    const handleInputChange = (e) => {
        const text = e.target.value;
        setInputValue(text);
        onChange(text);
    }

    const handleKeyPress = (e) => {
        const text = e.target.value;
        let code = event.keyCode || event.which;
        if (code === 13) {
            e.preventDefault();
            onPressEnter(text);
        }
    }

    return (
        <input 
            className={className} 
            type="text" 
            value={inputValue} 
            placeholder={placeholder}
            onChange={(e) => handleInputChange(e)}
            onKeyPress={(e) => handleKeyPress(e)}
            onFocus={onFocus}
            onBlur={onBlur}
        />
    )
}

export default SearchBox;
